class IndexBannerSwiper extends HTMLElement {
    constructor() {
        super();
        this._swiperInstance = null;
    }

    connectedCallback() {
        const swiperContainer = this.querySelector('.swiper');
        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        const swiper_pagi = this.querySelector('.swiper-pagination');
        const autoplayValue = this.getAttribute('data-autoplay');
        const blockSize = this.getAttribute('data-block-size');

        if (blockSize > 1) {
            this._swiperInstance = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 0,
                autoHeight: true,
                autoPlay: autoplayValue,
                loop: this.getAttribute('data-loop'),
                navigation: {
                    nextEl: nextButton || null,
                    prevEl: prevButton || null,
                },
                pagination: {
                    el: swiper_pagi || null,
                    clickable: true,
                }
            });
        }

    }

}

customElements.define('indexbanner-swiper', IndexBannerSwiper);

$(function () {
    $('.swiper-pagination .swiper-pagination-bullet').on('mouseenter touchstart', function () {
        $(this).click();
    });
})

